
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoshirdicab() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Cab',
        heading: 'S9 Travels:  Pune to Shirdi Cab',
        headingDescription: 'S9 Travels offers reliable and comfortable Pune to Shirdi cab services, ensuring a smooth and hassle-free journey for pilgrims and travelers. The distance from Pune to Shirdi is approximately 185 km, with a travel time of around 4 to 5 hours by road. Our well-maintained cabs, professional drivers, and top-notch customer service guarantee a safe and comfortable ride. Whether traveling for a spiritual visit or a leisure trip, S9 Travels provides a seamless travel experience.',

        top: 'Top Places to Visit in Shirdi with S9 Travels',

"topPlaces": [
    {
      "title": "Shri Sai Baba Samadhi Mandir",
      "description": "The Shri Sai Baba Samadhi Mandir is the most revered temple in Shirdi, housing the final resting place of Sai Baba. Devotees from all over the world visit to seek blessings and experience the spiritual aura of the temple."
    },
    {
      "title": "Dwarkamai",
      "description": "Dwarkamai is a sacred mosque where Sai Baba spent a significant part of his life. It is believed to be a place of miracles, where Baba lit lamps with water and healed the sick. It remains a place of deep devotion for his followers."
    },
    {
      "title": "Chavadi",
      "description": "Chavadi holds great historical and spiritual significance as Sai Baba used to sleep here on alternate nights. The site is now a temple and plays an important role in religious processions in Shirdi."
    },
    {
      "title": "Shri Sai Baba Sansthan Trust Museum",
      "description": "This museum showcases various personal belongings of Sai Baba, including his clothing, utensils, and walking stick. It provides insights into his simple yet impactful life and teachings."
    },
    {
      "title": "Gurusthan",
      "description": "Gurusthan is believed to be the place where Sai Baba was first spotted meditating under a neem tree as a young ascetic. Devotees believe that lighting incense sticks here brings good health and prosperity."
    },
    {
      "title": "Khandoba Temple",
      "description": "This temple is dedicated to Lord Khandoba and is significant in Shirdi’s history. It is where Sai Baba was first recognized as a saint by a local priest, marking the beginning of his divine journey."
    },
    {
      "title": "Lendi Baug",
      "description": "Lendi Baug is a beautiful garden where Sai Baba used to meditate and water the plants. The garden has a sacred lamp (Nanda Deep) that Baba lit and which continues to burn today."
    },
    {
      "title": "Maruti Mandir",
      "description": "One of the oldest temples in Shirdi, Maruti Mandir is dedicated to Lord Hanuman. It is believed that Sai Baba often visited this temple, making it a place of spiritual significance."
    },
    {
      "title": "Sai Heritage Village",
      "description": "Sai Heritage Village is a unique theme park that showcases the life and miracles of Sai Baba through beautiful sculptures and dioramas. It’s an educational and devotional attraction for visitors."
    },
    {
      "title": "Wet N Joy Water Park",
      "description": "For those looking for some fun and relaxation, Wet N Joy Water Park in Shirdi offers thrilling water slides, wave pools, and family-friendly attractions, making it a great place to unwind after a spiritual visit."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Airport Round Trip Innova",
      "description": "For those who need a round-trip taxi to Mumbai Airport, our Innova cabs offer a great option. Book a round trip to ensure you have a reliable vehicle both ways. Our round-trip service includes pick-up from Pune, a safe journey to the airport, and a return trip after your flight."
    },
    {
      "name": "Private Innova Cab from Pune to Mumbai Airport",
      "description": "Book a private Innova cab for your Pune to Mumbai Airport trip. Whether you’re traveling alone, with family, or in a group, having a private vehicle ensures that you can travel in privacy and comfort."
    },
    {
      "name": "Affordable Pune to Mumbai Airport Innova",
      "description": "Travel affordably with an Innova taxi from Pune to Mumbai Airport. We offer competitive prices without compromising on comfort. Whether it’s a solo trip or with family, our affordable Innova taxis ensure great value for money."
    },
    {
      "name": "Group Travel to Mumbai Airport by Innova",
      "description": "Traveling with a group? Our Innova cabs are ideal for group travel to Mumbai Airport. With ample space for luggage and passengers, everyone can travel together in comfort. Book a group travel Innova for a smooth and enjoyable airport trip."
    },
    {
      "name": "Luxury Innova for Mumbai Airport",
      "description": "For those looking for a luxury ride to Mumbai Airport, our luxury Innova cabs offer premium features such as plush seating, air conditioning, and a smooth ride for a top-tier travel experience. Perfect for business travelers or those looking for extra comfort."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Airport Round Trip Innova", "Private Innova Cab from Pune to Mumbai Airport"],
    ["Affordable Pune to Mumbai Airport Innova", "Group Travel to Mumbai Airport by Innova"],
    ["Luxury Innova for Mumbai Airport", "Pune to Mumbai Airport Round Trip Innova"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of arriving at your destination on time. Whether you're traveling from Pune to Shirdi, we ensure prompt pickups and a smooth journey. Our drivers are punctual and committed to getting you to Shirdi comfortably and on schedule."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the ideal vehicle for your journey from Pune to Shirdi. With comfortable seating, air conditioning, and ample space for luggage, you can enjoy a relaxing and stress-free trip. Whether you're traveling alone or with family and friends, you’ll experience comfort throughout the ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes from Pune to Shirdi. They are courteous, knowledgeable, and dedicated to ensuring a smooth and enjoyable journey. With their expertise, you can relax and enjoy the trip without any concerns."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Shirdi cab ride. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, allowing you to plan your travel comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. You can rest assured that your journey from Pune to Shirdi will be secure and comfortable."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "No matter when you need to travel, S9 Travels is available 24/7. Whether you want to start your journey early in the morning or late in the evening, our rides are ready to serve you, and our customer service team is always available to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Shirdi cab is simple and hassle-free with S9 Travels. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance in securing your cab."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your journey from Pune to Shirdi. Whether you need additional stops along the way or have specific preferences, we can tailor the trip to meet your needs and make your experience more enjoyable."
  }
]












    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Shirdi with S9 Travels?',
            answer: 'Booking a cab for your Pune to Shirdi trip is simple! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Pune to Shirdi travel?',
            answer: 'We offer various cabs, including the spacious Toyota Innova, which is perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that best suits your needs for a comfortable journey.'
          },
          {
            question: 'Are the drivers experienced for the Pune to Shirdi route?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Pune to Shirdi. They ensure a smooth, safe, and timely journey, making sure you arrive at your destination comfortably.'
          },
          {
            question: 'What payment options are available for booking a cab from Pune to Shirdi?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments via our mobile app for your convenience.'
          },
          {
            question: 'Can I book a round trip from Pune to Shirdi?',
            answer: 'Yes, we offer round-trip bookings. Just provide us with your return details, and we’ll arrange for your return ride from Shirdi to Pune, ensuring a hassle-free experience.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges, such as for detours or waiting time, will be communicated to you upfront, ensuring full transparency in the pricing structure.'
          },
          {
            question: 'Can I make additional stops on the way to Shirdi?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we’ll accommodate your requests for stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Pune to Shirdi trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or specific requirements, please let us know when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Pune to Shirdi?',
            answer: 'Yes, we offer corporate travel services for business trips from Pune to Shirdi, ensuring that your journey is comfortable, punctual, and professional.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Shirdi cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey to Shirdi.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Pradeep Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a ride from Pune to Shirdi with S9 Travels, and I couldn’t be more satisfied. The driver was professional, the car was clean, and the journey was comfortable. I highly recommend S9 Travels for anyone traveling to Shirdi!”'
        },
        {
          name: 'Mrs. Rupal Desai',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family used S9 Travels for a trip to Shirdi from Pune, and the experience was excellent. The vehicle was spacious and clean, and the driver was courteous and punctual. I will definitely book again for our next trip!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Shirdi Cab",
        "description": "Book comfortable and affordable Pune to Shirdi cab services with S9 Travels. Enjoy a smooth and safe ride with experienced drivers for your pilgrimage or leisure trip. Whether you need a one-way or round-trip, we provide flexible schedules and well-maintained vehicles for your convenience.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "5432"
        }
      };
      

      


    return (
        <div>
              <Helmet>
        <title>Pune to Shirdi Cab | Safe & Comfortable Taxi Service | S9 Travels</title>
        <meta 
          name="description" 
          content="Book your Pune to Shirdi cab with S9 Travels. Travel comfortably and safely to Shirdi with professional drivers, flexible schedules, and affordable pricing for a smooth and hassle-free journey." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/90.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdicab;